import React from "react";
import { Helmet } from "react-helmet";
import GoToTop from "../GoToTop";

function Contact() {
  return (
    <>
      {" "}
      <Helmet>
        <title>DibruGo | Taxi Service in Dibrugarh</title>
        <meta
          name="description"
          content="Book reliable taxi service in Dibrugarh with DibruGo. Affordable airport transfers, local rides, and outstation trips with professional drivers."
        />
        <meta
          property="og:title"
          content="DibruGo – Best Taxi Service in Dibrugarh | Airport & Local Cabs"
        />
        <meta
          property="og:description"
          content="Book reliable taxi service in Dibrugarh with DibruGo. Affordable airport transfers, local rides, and outstation trips with professional drivers."
        />
        <script type="application/ld+json">
          {`
         {
"@context": "https://schema.org",
"@type": "FAQPage",
"mainEntity": [
{
"@type": "Question",
"name": "How can I book a taxi in Dibrugarh?",
"acceptedAnswer": {
"@type": "Answer",
"text": "You can book a taxi online through DibruGo."
}
},
{
"@type": "Question",
"name": "Does DibruGo provide airport taxi?",
"acceptedAnswer": {
"@type": "Answer",
"text": "Yes, DibruGo provides taxi services to and from Dibrugarh Airport."
}
}
]
}
          `}
        </script>
      </Helmet>
      <GoToTop />
      <div
        className="container section-about web-main pb-4"
        style={{ textAlign: "justify" }}
      >
        <div className="d-flex align-items-center mt-4 mb-3">
          <div className="heading-dash-primary" />
          <h1
            className="fw-bold mb-0 d-flex align-items-center"
            style={{ fontSize: "20px", color: "#f49e00" }}
          >
            Contact Us
          </h1>
        </div>

        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d221.27438340145957!2d95.01292258501051!3d27.457111088066274!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4602c11be7ab925%3A0x43a23a4a1fc141ee!2sDibruGo!5e0!3m2!1sen!2sin!4v1774292603759!5m2!1sen!2sin"
        
          height="250"
                  style={{ border: "0",width:'100%' }}
          allowfullscreen=""
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"
              ></iframe>
              

              <h5 className="mt-3 text-center mb-2">Get in Touch</h5>
              <input className="form-control mb-2" placeholder="Enter Full Name"/>
              <input className="form-control  mb-2" placeholder="Enter Contact No"/>
              <input className="form-control  mb-2" placeholder="Enter Email Id" />
              <textarea className="form-control  mb-2" placeholder="Write your message here"></textarea>
              <button className="btn btn-dark">Submit</button>
      </div>
    </>
  );
}

export default Contact;
